import { comerciosService } from "../../../_services/comercios.service";
import { deudasService } from "../../../_services/deudas.service";
// import { deudasService } from "../../../_services/deudas.service";
import { dashboardConstants } from "../constants";

export const getComercios = (data) => async (dispatch) => {
  dispatch(request());
  try {
    let response = [];

    if (data.com) {
      let res = await deudasService.existeComercio(data.com);
      response = res.data?.data ? [res.data?.data] : [];
    }
    else {
      let res = await comerciosService.comercioxVarios(data);

      response = res.data?.comercios;
    }

    // if (data.cc) {
    //   const resDeuda = await deudasService.comercioxCC(data.cc);
    //   resDeuda.data.data.forEach((c) => {
    //     if (!comercios.some((n) => n === c.NRO_COMERCIO)) {
    //       comercios.push(c.NRO_COMERCIO);
    //     }
    //   });
    // }
    // if (data.nro_comercio) {
    //   comercios.push(data.nro_comercio);
    // }

    if (!Array.isArray(response)) {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED, payload: { comerciosList: [] } };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_COMERCIOS_LIST, payload: list };
  }
};

export const setComercios = (data) => async (dispatch) => {
  function success(list) {
    return { type: dashboardConstants.SET_COMERCIOS_LIST, payload: list };
  }

  return dispatch(success(data));
};